// extracted by mini-css-extract-plugin
export default {"wrap":"fJ-z","fullWidth":"gJ-z","hideOnDesktop":"hJ-z","content":"iJ-z","hasOpenedNav":"jJ-z","crumbsList":"kJ-z","dropdownsWrap":"lJ-z"};